import { Component, OnInit , ViewChild} from '@angular/core';
import { CropperComponent } from 'angular-cropperjs';
// import { SortablejsModule } from 'ngx-sortablejs';
@Component({
  selector: 'app-pictures',
  templateUrl: './pictures.page.html',
  styleUrls: ['./pictures.page.scss'],
})
export class PicturesPage implements OnInit {
  @ViewChild('angularCropper')
  public angularCropper: CropperComponent = new CropperComponent;
  cropperOptions: any;
  croppedImage = null;
  showCropper: boolean = false;
 
  myImage = null;
  scaleValX = 1;
  scaleValY = 1;


  public userData : any;
  // lastImage: string = null;

  public static gray : string = 'assets/imgs/gray-005.jpg';
  public static get grayPlus(): string {
    return isDarkMode() ? 'assets/imgs/add-img2.svg' : 'assets/imgs/add-img.svg';
  }
  
  // private gray : string = PicturesPage.gray;
  // private grayPlus : string = PicturesPage.grayPlus;
  
  public static loading : string = 'assets/imgs/loading.gif';
  public static noImage : string = 'assets/imgs/no-picture.png';
  public static noPicture : string = 'assets/imgs/no-picture.png';
  
  public pictures : string[] = [PicturesPage.gray, PicturesPage.gray, PicturesPage.gray, PicturesPage.gray, PicturesPage.gray, PicturesPage.gray, PicturesPage.gray, PicturesPage.gray, PicturesPage.gray];
  private picHasChanged : boolean = false;
  private picChanged : boolean[] = [false, false, false, false, false, false, false, false, false];
  private shuffling : boolean = false;
  private preShufflePictures : string[] = [];
  private preShuffleUserData : any;
  private isNative : boolean = true;
  // private workingOnIndex : number;

  constructor() { }

  ngOnInit() {
  }
    
}

function isDarkMode(): boolean {
  return document.documentElement.getAttribute('color-theme') === 'dark';
}